var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "signature-templates" },
    [
      _c("TMSHeader", {
        attrs: {
          buttons: _vm.btnOptions,
          needGoback: false,
          title: _vm.updateInfo,
        },
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "templates" },
        [
          _vm._l(_vm.templates, function (template, index) {
            return _c(
              "div",
              { key: template.id, staticClass: "template-detail" },
              [
                _vm.canEdit
                  ? _c(
                      "div",
                      {
                        staticClass: "remove",
                        on: {
                          click: function ($event) {
                            return _vm.deleteTemplate(index)
                          },
                        },
                      },
                      [_c("i", { staticClass: "fa fa-times fa-lg" })]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c("InputField", {
                  staticClass: "small-6 medium-6 large-6",
                  attrs: {
                    label: _vm.$t("signature") + " " + _vm.$t("name"),
                    readonly: !_vm.canEdit,
                    showColon: false,
                    required: _vm.canEdit,
                    defaultEmpty: "",
                  },
                  on: {
                    updateValue: function (val) {
                      return (template.title = val)
                    },
                  },
                  model: {
                    value: template.title,
                    callback: function ($$v) {
                      _vm.$set(template, "title", $$v)
                    },
                    expression: "template.title",
                  },
                }),
                _vm._v(" "),
                _vm.isSignatureForTenant
                  ? _c(
                      "div",
                      {
                        staticClass: "small-6 medium-6 large-6",
                        class: {
                          "highlight-empty":
                            _vm.highlightEmpty && _vm.emptyZones[index],
                        },
                      },
                      [
                        _c(
                          "label",
                          {
                            class: [
                              "title",
                              {
                                "required-flag": _vm.canEdit,
                                "margin-top": !_vm.canEdit,
                              },
                            ],
                          },
                          [_vm._v(_vm._s(_vm.$t("eCircular.zone")))]
                        ),
                        _vm._v(" "),
                        _vm.canEdit
                          ? _c("HKLMultiSelect", {
                              attrs: {
                                options: _vm.zoneOptions,
                                value: template.zones,
                                placeholder: "",
                                searchable: false,
                              },
                              on: {
                                change: function (val) {
                                  template.zones = val
                                  _vm.formUtils.setDirty()
                                },
                              },
                            })
                          : _c("p", { staticClass: "zone" }, [
                              _vm._v(_vm._s((template.zones || []).join("; "))),
                            ]),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c("SignatureEditor", {
                  attrs: {
                    label: _vm.$t("signature"),
                    content: template.content,
                    updateContent: function (val) {
                      return _vm.updateContent(val, index)
                    },
                    isEditing: _vm.canEdit,
                    previewKey: template.id,
                  },
                }),
              ],
              1
            )
          }),
          _vm._v(" "),
          _c(
            "modal",
            {
              ref: "cancelModal",
              attrs: {
                showCloseBtn: false,
                modalId: "cancel-signature-update-" + +new Date(),
              },
            },
            [
              _c("div", { attrs: { slot: "content" }, slot: "content" }, [
                _c("div", { staticClass: "font-bold" }, [
                  _vm._v(_vm._s(_vm.$t("cancelChanges"))),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { attrs: { slot: "btns" }, slot: "btns" }, [
                _c(
                  "button",
                  {
                    staticClass: "btn--darkblue",
                    attrs: { type: "button" },
                    on: { click: _vm.closeModal },
                  },
                  [_vm._v(_vm._s(_vm.$t("action.no")))]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "btn--orange",
                    attrs: { type: "button" },
                    on: { click: _vm.cancel },
                  },
                  [_vm._v(_vm._s(_vm.$t("action.yesContinue")))]
                ),
              ]),
            ]
          ),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }